// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageTitleStyles } from "@guestsupply/Overrides/Widgets/Basic/PageTitle";
import CaretLeft from "@guestsupply/XDL/Icons/CaretLeft";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

pageTitleStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};
pageTitleStyles.goBackLink = {
    ...createLinkIconStyles(CaretLeft, {
        icon: {
            iconProps: {
                size: 14,
            },
            position: "left",
        },
        css: css`
            margin-top: 5px;
            /* XNG-Changes: same as classic */
            ${xScreen("lte", 640)} {
                display: none;
            }
        `,
    }),
};
